var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { NoPhoneFilledIcon } from "@gemini/icons";
import { useState } from "react";
import { NoPhoneElement, PhoneContactInfosWrapper } from "./ui";
import { PhoneItem } from "./PhoneBlock";
import { useContactingTestId, useCustomerAction } from "@/hooks";
import { useContactCardSection } from "@/contexts/contact";
import { useI18n } from "@/shared/hooks";
import { PhoneButton } from "@/components/contacting/Buttons";
import { useCallTracking, useCallTrackingPhoneNumbers, } from "@/contexts/callTracking";
import { IS_SERVER } from "@/constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const PhoneContactInfos = ({ justifyContent = "center", alignItems, size = "48", isFullwidth = true, phoneNumbersGap = "spacing.12", }) => {
    var _a;
    const testId = useContactingTestId("PhoneContactInfos");
    const { phoneNumbers = [] } = (_a = useContactCardSection()) !== null && _a !== void 0 ? _a : {};
    const [phoneDisplayed, setPhoneDisplayed] = useState(false);
    const hasPhoneNumbers = phoneNumbers.length > 0;
    const { t } = useI18n();
    const { customerActionExposeContactPhoneCall } = useCustomerAction();
    const { isCallTrackingRequestDone } = useCallTracking();
    const virtualPhoneNumbers = useCallTrackingPhoneNumbers();
    const displayedPhoneNumbers = virtualPhoneNumbers !== null && virtualPhoneNumbers !== void 0 ? virtualPhoneNumbers : phoneNumbers;
    const isPreviewMode = useIsPreviewMode();
    const onPressPhoneView = () => {
        if (isPreviewMode)
            return;
        setPhoneDisplayed(true);
    };
    const onPressPhoneCall = (phoneNumber) => __awaiter(void 0, void 0, void 0, function* () {
        if (IS_SERVER || !phoneNumber || isPreviewMode)
            return;
        yield customerActionExposeContactPhoneCall();
        // eslint-disable-next-line no-restricted-globals
        window.location.href = `tel:${phoneNumber.replace(/\s/g, "")}`;
    });
    return (_jsxs(PhoneContactInfosWrapper, { testId: testId, flexDirection: phoneDisplayed ? "column" : "row", justifyContent: justifyContent, alignItems: alignItems, children: [hasPhoneNumbers &&
                (!phoneDisplayed || !isCallTrackingRequestDone ? (_jsx(PhoneButton, { isFullWidth: isFullwidth, size: size, trackingAvZone: "contact_card", legacyTrackingInfos: "detail-right", rootTestId: testId, onPress: onPressPhoneView, displayPhoneNumbers: true, children: t("contact.card.show_phone") })) : (_jsx(Box, { paddingVertical: "spacing.12", display: "flex", gap: "spacing.12", flexDirection: "column", children: displayedPhoneNumbers.map((phoneNumber, index) => (_jsx(Box, { as: "div", onClick: () => onPressPhoneCall(phoneNumber), children: _jsx(PhoneItem, { index: index, phoneNumber: phoneNumber, testId: testId }, `phoneNumber-${phoneNumber}`) }, phoneNumber))) }))), !hasPhoneNumbers && (_jsxs(Box, { display: "flex", gap: phoneNumbersGap, alignItems: "center", children: [_jsx(NoPhoneFilledIcon, { size: "sizing.16", color: "color.content.disabled" }), _jsx(NoPhoneElement, { testId: `${testId}.NoPhone`, children: t("contact.card.no_phone") })] }))] }));
};
